import { PulseProviderInput } from '@pulse/react';

export const REMOTE_SETTINGS: PulseProviderInput = {
  sdks: ['settings', 'tracker'],
  settings: { defaults: {} },
  app: 'picsart.com',
};

export const COLLECTIONS_TO_FOLDERS_CONFIG = {
  name: 'collection_to_folders_enabled',
  tag: 'collection_to_folders_enabled',
};

export default {
  REMOTE_SETTINGS,
};
